import {
  TYPE2CLASS
} from '../core/icon-class';
import {
  Fact
} from '../common/fact';
import {
  PATH_STRING_SEPARATOR
} from '../common/config.js';
import {
  IncidentsModalController
} from './add-to-incidents/incidents-modal.component';

class FactThumbController {
  constructor(
    $scope,
    $element,
    $timeout,
    RouterService,
    AlertModalService,
    $modal,
    $http,
    FaceService,
    SpecialModalService,
  ) {
    this.isImage = Fact.isImage;
    this.router = RouterService;
    this.AlertModalService = AlertModalService;
    this.sep = PATH_STRING_SEPARATOR;

    $scope.toUserNearestScreenshot = () => {
      this.router.needToShowFact = {
        needShowScreenshot: false,
        fact: this.fact,
        date: this.fact.local_time
      };
      this.router.toUserNearestScreenshot();
      this.router.filterChanged();
    };

    $scope.addToIncidents = () => {
      // console.log($scope.fact);
      this.modalInstance = $modal
        .open({
          template: require('./add-to-incidents/incidents-modal.component.html'),
          controller: IncidentsModalController,
          scope: $scope,
        })
        .result.then(() => {
          // console.log(res);
        }, err => {
          this.AlertModalService.open(`${err.status} ${err.status ? err.statusText :''}`, err.data);
        });
    };

    $scope.toNeighbourEvents = () => {
      this.router.needToShowFact = {
        fact: this.fact,
        date: this.fact.local_time
      };
      this.router.toNeighbourEvents();
      this.router.filterChanged();
    };

    $scope.findSimular = () => {
      $scope.router.findSimular($scope.fact.id);
    };

    $scope.deleteEvent = () => {
      SpecialModalService.deleteEvent(this.fact.id, function onSuccess() {
        $scope.$emit('reload');
      });
    };


  }

  get icon() {
    return this.fact && TYPE2CLASS[this.fact['agent_eventtype.name']];
  }
}

export const FactThumbComponent = {
  bindings: {
    filter: '<',
    fact: '<',
    openImage: '<',
    listType: '<',
    selected: '<',
  },
  controller: FactThumbController,
  template: require('./fact-thumb.component.html'),
};



// WEBPACK FOOTER //
// ./src/facts/fact-thumb.component.js